import { useContext, } from 'react';
import { UserContext } from '../UserContext';
import React, { useState, useRef } from 'react';
import api from '../api';
import { useEffect } from 'react';
import "../styles/profile.css";
import Cropper from 'react-easy-crop'
import getCroppedImg from '../components/getCroppedImg';
const apiEndpoint = process.env.REACT_APP_API_URL;

function Profile() {
    const { user, setUser } = useContext(UserContext);
    const [updateshow, setUpdateShow] = useState(false);
    const [updateid, setUpdateId] = useState(null);

    const handleshow = (id) => {
        setUpdateShow(true);
        setUpdateId(id);
    };

    const updatehandleclose = () => {
        setUpdateShow(false);
        setUpdateId(null);
    };

    const deleteSocial = async (socialId) => {
        try {
            const res = await api.delete(`api/social_media/`, {
                data: { socialId }
            });
            if (res.status === 200) {
                setUser(prevUser => ({
                    ...prevUser,
                    socials: prevUser.socials.filter(social => social.id !== socialId)
                }));
            }
        }
        catch (error) {
            alert("oooppsss! some error occured, pls refresh the page");
        }
    }

    const deleteManuelSocial = async (socialId) => {
        try {
            const res = await api.delete(`api/manuel_social_media/`, {
                data: { socialId }
            });
            if (res.status === 200) {
                setUser(prevUser => ({
                    ...prevUser,
                    manule_socials: prevUser.manule_socials.filter(social => social.id !== socialId)
                }));
            }
        }
        catch (error) {
            alert("oooppsss! some error occured, pls refresh the page");
        }
    }

    const deleteLink = async (linkId) => {
        try {
            const res = await api.delete(`api/linkview/`, {
                data: { linkId }
            });
            if (res.status === 200) {
                setUser(prevUser => ({
                    ...prevUser,
                    links: prevUser.links.filter(link => link.id !== linkId)
                }));
            }
        }
        catch (error) {
            alert("oooppsss! some error occured, pls refresh the page");
        }
    }

    function AddSocialMedia() {
        const { user, setUser } = useContext(UserContext);
        const [socialMediaUsername, setSocialMediaUsername] = useState("");
        const [socialMedia, setSocialMedia] = useState("");
        const [errors, setErrors] = useState([]);
        const [show, setShow] = useState(false);
        const [loading, setLoading] = useState(false);
        const [tags, setTags] = useState([]);
        const [tag, setTag] = useState("");
        const [countrys, setCountrys] = useState([]);
        const [tagsuggeslist, setSagsuggeslist] = useState([]);
        const [selectedCountry, setSelectedCountry] = useState("Choose...");
        const textRef = useRef(null);

        const handleCopy = () => {
            if (textRef.current) {
                navigator.clipboard.writeText(textRef.current.innerText).then(() => {
                });
            }
        };

        const handleSetTag = (e) => {
            setTag(e);
            if (e === "") {
                setSagsuggeslist([]);
            } else {
                setTag(e);
            }
        };
        const setonetag = () => {
            if (!tags.includes(tag)) {
                setTags([...tags, tag]);
            }
            setTag("");
        }
        useEffect(() => {
            if (tag === "") {
                setSagsuggeslist([]);
                return;
            }
            setSagsuggeslist(
                user.tags.filter((t) =>
                    t.name.startsWith(tag)
                )
            );
            // eslint-disable-next-line
        }, [tag]);

        const handleCountryChange = (event) => {
            const selected = event.target.value;

            if (countrys.length === 5) {
                setErrors(["You can only select 5 countries."]);
                return;
            }

            if (selected !== "Choose..." && !countrys.includes(selected)) {
                setCountrys([...countrys, selected]);
            }

            // Seçimi sıfırla
            setSelectedCountry("Choose...");
        };

        const handleShow = () => {
            setShow(true);
        };

        // const handleSubmit = async (e) => {
        //     e.preventDefault();
        //     if (socialMedia === "") {
        //         setErrors(["Please select a social media."])
        //         return;
        //     }

        //     if (tags.length > 10) {
        //         setErrors(["You can only select 10 tags."])
        //         return;
        //     }

        //     try {
        //         setLoading(true);

        //         const res = await api.post('api/social_media/', { socialMedia, socialMediaUsername, tags, countrys });

        //         if (res.status === 200 && !(user.socials.some(social => social.social_media === socialMedia))) {
        //             setUser(prevUser => ({
        //                 ...prevUser,
        //                 socials: [...prevUser.socials, res.data]
        //             }));
        //         }
        //         handleClose();
        //     }
        //     catch (error) {
        //         setErrors([error.response.data])
        //         return;
        //     }
        //     finally {
        //         setLoading(false)
        //     }

        // }

        const handleManualSubmit = async (e) => {
            e.preventDefault();

            if (socialMedia === "") {
                setErrors(["Please select a social media."])
                return;
            }

            if (tags.length > 10) {
                setErrors(["You can only select 10 tags."])
                return;
            }
            if (socialMediaUsername === "") {
                setErrors(["Please enter a username."])
                return;
            }

            try {
                setLoading(true);
                const res = await api.post('api/manuel_social_media/', { socialMedia, socialMediaUsername, tags, countrys });
                if (res.status === 200 && !(user.manule_socials.some(manule_socials => manule_socials.social_media === socialMedia))) {
                    setUser(prevUser => ({
                        ...prevUser,
                        manule_socials: [...prevUser.manule_socials, res.data]
                    }));
                }
                handleClose();
            }
            catch (error) {

                setErrors([error.response.data])
                return;
            }
            finally {
                setLoading(false)
            }

        }

        const handleClose = () => {
            setErrors([]);
            setSocialMedia("");
            setSocialMediaUsername("");
            setTags([]);
            setTag("");
            setShow(false);
        }

        return (<>
            <div className="mt-3">
                <button onClick={handleShow} className="icon-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>
                </button>
            </div>
            {
                show && (
                    <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id="exampleModalLabel">Add Social Media</h1>
                                </div>
                                <div className="modal-body">

                                    <form>

                                        <div className="input-group mb-3">
                                            <label className="input-group-text" htmlFor="inputGroupSelect01">Social Media</label>
                                            <select className="form-select"
                                                id="inputGroupSelect01"
                                                required
                                                value={socialMedia}
                                                onChange={(e) => setSocialMedia(e.target.value)}
                                            >
                                                <option defaultValue=""  >Choose...</option>
                                                <option value="Instagram">Instagram</option>
                                                <option value="Tiktok">Tiktok</option>
                                                <option value="Facebook">Facebook</option>
                                                <option value="X">X</option>
                                                <option value="Youtube">Youtube</option>
                                            </select>
                                        </div>

                                        {["Instagram", "Tiktok", "X", "Youtube"].includes(socialMedia) && (
                                            <div>

                                                <img
                                                    src={`${apiEndpoint}/media/photos/${socialMedia}.jpg`}
                                                    alt=""
                                                    style={{ width: "175px", borderRadius: "5px", marginBottom: "5px" }}
                                                />
                                                <p className='error'>Make sure your username is correct</p>

                                            </div>
                                        )}

                                        {socialMedia === "Facebook" && (
                                            <div>

                                                <img
                                                    src={`${apiEndpoint}/media/photos/facebook_mobile_3.jpg`}
                                                    alt=""
                                                    style={{ width: "100%", borderRadius: "5px", marginBottom: "5px", marginRight: "5px" }}
                                                />
                                                <p>If you are on your phone, follow the steps above, copy your profile link and paste it in place of your username. If you are on your computer, copy the link in your profile as below and paste it into the username section.</p>
                                                <img
                                                    src={`${apiEndpoint}/media/photos/facebook_pc.JPG`}
                                                    alt=""
                                                    style={{ width: "100%", borderRadius: "5px", marginBottom: "10px", marginRight: "5px" }}
                                                />

                                            </div>)
                                        }


                                        <input className="form-control rounded-3"
                                            type="text"
                                            value={socialMediaUsername}
                                            onChange={(e) => setSocialMediaUsername(e.target.value)}
                                            placeholder="username"
                                            maxLength={254}
                                            required
                                        />

                                        <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                                            {
                                                <ul style={{ padding: "0" }}>
                                                    {errors.map((error, index) => (
                                                        <li key={index}>{` ${error}`}</li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>

                                        <h4>Tags: </h4>
                                        <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                            {
                                                tags.map((tag, index) => (
                                                    <span key={index} onClick={() => setTags(tags.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{tag}</span>
                                                ))}

                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    value={tag}
                                                    onChange={(e) => handleSetTag(e.target.value)}
                                                    placeholder="Tag"
                                                    maxLength={254}
                                                />
                                                <ul className="dropdown-menu" >
                                                    {tagsuggeslist.map((tag, index) => (
                                                        // eslint-disable-next-line
                                                        <li key={index}><a className="dropdown-item" onClick={() => setTag(tag.name)}>{tag.name}</a></li>
                                                    ))}
                                                </ul>


                                                <button onClick={() => { if (tag === "") { return } setonetag() }} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                            </div>

                                        </div>
                                        <small>Click on the tag to delete it</small>

                                        <h4 className=' py-3'>Community locations: </h4>
                                        <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                            {countrys.map((country, index) => (
                                                <span key={index} onClick={() => setCountrys(countrys.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{country}</span>
                                            ))}

                                            <select id="country" name="country" className="form-control" value={selectedCountry} onChange={handleCountryChange}>
                                                <option defaultValue={"Choose..."}></option>
                                                <option value="Global">Global</option>

                                                <option value="Afghanistan">Afghanistan</option>
                                                <option value="Åland Islands">Åland Islands</option>
                                                <option value="Albania">Albania</option>
                                                <option value="Algeria">Algeria</option>
                                                <option value="American Samoa">American Samoa</option>
                                                <option value="Andorra">Andorra</option>
                                                <option value="Angola">Angola</option>
                                                <option value="Anguilla">Anguilla</option>
                                                <option value="Antarctica">Antarctica</option>
                                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Armenia">Armenia</option>
                                                <option value="Aruba">Aruba</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Austria">Austria</option>
                                                <option value="Azerbaijan">Azerbaijan</option>
                                                <option value="Bahamas">Bahamas</option>
                                                <option value="Bahrain">Bahrain</option>
                                                <option value="Bangladesh">Bangladesh</option>
                                                <option value="Barbados">Barbados</option>
                                                <option value="Belarus">Belarus</option>
                                                <option value="Belgium">Belgium</option>
                                                <option value="Belize">Belize</option>
                                                <option value="Benin">Benin</option>
                                                <option value="Bermuda">Bermuda</option>
                                                <option value="Bhutan">Bhutan</option>
                                                <option value="Bolivia">Bolivia</option>
                                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                                <option value="Botswana">Botswana</option>
                                                <option value="Bouvet Island">Bouvet Island</option>
                                                <option value="Brazil">Brazil</option>
                                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                                <option value="Bulgaria">Bulgaria</option>
                                                <option value="Burkina Faso">Burkina Faso</option>
                                                <option value="Burundi">Burundi</option>
                                                <option value="Cambodia">Cambodia</option>
                                                <option value="Cameroon">Cameroon</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Cape Verde">Cape Verde</option>
                                                <option value="Cayman Islands">Cayman Islands</option>
                                                <option value="Central African Republic">Central African Republic</option>
                                                <option value="Chad">Chad</option>
                                                <option value="Chile">Chile</option>
                                                <option value="China">China</option>
                                                <option value="Christmas Island">Christmas Island</option>
                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Comoros">Comoros</option>
                                                <option value="Congo">Congo</option>
                                                <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                                <option value="Cook Islands">Cook Islands</option>
                                                <option value="Costa Rica">Costa Rica</option>
                                                <option value="Cote D'ivoire">Cote D'ivoire</option>
                                                <option value="Croatia">Croatia</option>
                                                <option value="Cuba">Cuba</option>
                                                <option value="Cyprus">Cyprus</option>
                                                <option value="Czech Republic">Czech Republic</option>
                                                <option value="Denmark">Denmark</option>
                                                <option value="Djibouti">Djibouti</option>
                                                <option value="Dominica">Dominica</option>
                                                <option value="Dominican Republic">Dominican Republic</option>
                                                <option value="Ecuador">Ecuador</option>
                                                <option value="Egypt">Egypt</option>
                                                <option value="El Salvador">El Salvador</option>
                                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                                <option value="Eritrea">Eritrea</option>
                                                <option value="Estonia">Estonia</option>
                                                <option value="Ethiopia">Ethiopia</option>
                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                                <option value="Faroe Islands">Faroe Islands</option>
                                                <option value="Fiji">Fiji</option>
                                                <option value="Finland">Finland</option>
                                                <option value="France">France</option>
                                                <option value="French Guiana">French Guiana</option>
                                                <option value="French Polynesia">French Polynesia</option>
                                                <option value="French Southern Territories">French Southern Territories</option>
                                                <option value="Gabon">Gabon</option>
                                                <option value="Gambia">Gambia</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Germany">Germany</option>
                                                <option value="Ghana">Ghana</option>
                                                <option value="Gibraltar">Gibraltar</option>
                                                <option value="Greece">Greece</option>
                                                <option value="Greenland">Greenland</option>
                                                <option value="Grenada">Grenada</option>
                                                <option value="Guadeloupe">Guadeloupe</option>
                                                <option value="Guam">Guam</option>
                                                <option value="Guatemala">Guatemala</option>
                                                <option value="Guernsey">Guernsey</option>
                                                <option value="Guinea">Guinea</option>
                                                <option value="Guinea-bissau">Guinea-bissau</option>
                                                <option value="Guyana">Guyana</option>
                                                <option value="Haiti">Haiti</option>
                                                <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                                <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                                <option value="Honduras">Honduras</option>
                                                <option value="Hong Kong">Hong Kong</option>
                                                <option value="Hungary">Hungary</option>
                                                <option value="Iceland">Iceland</option>
                                                <option value="India">India</option>
                                                <option value="Indonesia">Indonesia</option>
                                                <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                                <option value="Iraq">Iraq</option>
                                                <option value="Ireland">Ireland</option>
                                                <option value="Isle of Man">Isle of Man</option>
                                                <option value="Israel">Israel</option>
                                                <option value="Italy">Italy</option>
                                                <option value="Jamaica">Jamaica</option>
                                                <option value="Japan">Japan</option>
                                                <option value="Jersey">Jersey</option>
                                                <option value="Jordan">Jordan</option>
                                                <option value="Kazakhstan">Kazakhstan</option>
                                                <option value="Kenya">Kenya</option>
                                                <option value="Kiribati">Kiribati</option>
                                                <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                                <option value="Korea, Republic of">Korea, Republic of</option>
                                                <option value="Kuwait">Kuwait</option>
                                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                <option value="Latvia">Latvia</option>
                                                <option value="Lebanon">Lebanon</option>
                                                <option value="Lesotho">Lesotho</option>
                                                <option value="Liberia">Liberia</option>
                                                <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                                <option value="Liechtenstein">Liechtenstein</option>
                                                <option value="Lithuania">Lithuania</option>
                                                <option value="Luxembourg">Luxembourg</option>
                                                <option value="Macao">Macao</option>
                                                <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                                <option value="Madagascar">Madagascar</option>
                                                <option value="Malawi">Malawi</option>
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="Maldives">Maldives</option>
                                                <option value="Mali">Mali</option>
                                                <option value="Malta">Malta</option>
                                                <option value="Marshall Islands">Marshall Islands</option>
                                                <option value="Martinique">Martinique</option>
                                                <option value="Mauritania">Mauritania</option>
                                                <option value="Mauritius">Mauritius</option>
                                                <option value="Mayotte">Mayotte</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                                <option value="Moldova, Republic of">Moldova, Republic of</option>
                                                <option value="Monaco">Monaco</option>
                                                <option value="Mongolia">Mongolia</option>
                                                <option value="Montenegro">Montenegro</option>
                                                <option value="Montserrat">Montserrat</option>
                                                <option value="Morocco">Morocco</option>
                                                <option value="Mozambique">Mozambique</option>
                                                <option value="Myanmar">Myanmar</option>
                                                <option value="Namibia">Namibia</option>
                                                <option value="Nauru">Nauru</option>
                                                <option value="Nepal">Nepal</option>
                                                <option value="Netherlands">Netherlands</option>
                                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                                <option value="New Caledonia">New Caledonia</option>
                                                <option value="New Zealand">New Zealand</option>
                                                <option value="Nicaragua">Nicaragua</option>
                                                <option value="Niger">Niger</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="Niue">Niue</option>
                                                <option value="Norfolk Island">Norfolk Island</option>
                                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                <option value="Norway">Norway</option>
                                                <option value="Oman">Oman</option>
                                                <option value="Pakistan">Pakistan</option>
                                                <option value="Palau">Palau</option>
                                                <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                                <option value="Panama">Panama</option>
                                                <option value="Papua New Guinea">Papua New Guinea</option>
                                                <option value="Paraguay">Paraguay</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Philippines">Philippines</option>
                                                <option value="Pitcairn">Pitcairn</option>
                                                <option value="Poland">Poland</option>
                                                <option value="Portugal">Portugal</option>
                                                <option value="Puerto Rico">Puerto Rico</option>
                                                <option value="Qatar">Qatar</option>
                                                <option value="Reunion">Reunion</option>
                                                <option value="Romania">Romania</option>
                                                <option value="Russian Federation">Russian Federation</option>
                                                <option value="Rwanda">Rwanda</option>
                                                <option value="Saint Helena">Saint Helena</option>
                                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                                <option value="Saint Lucia">Saint Lucia</option>
                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                                <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                                <option value="Samoa">Samoa</option>
                                                <option value="San Marino">San Marino</option>
                                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                                <option value="Saudi Arabia">Saudi Arabia</option>
                                                <option value="Senegal">Senegal</option>
                                                <option value="Serbia">Serbia</option>
                                                <option value="Seychelles">Seychelles</option>
                                                <option value="Sierra Leone">Sierra Leone</option>
                                                <option value="Singapore">Singapore</option>
                                                <option value="Slovakia">Slovakia</option>
                                                <option value="Slovenia">Slovenia</option>
                                                <option value="Solomon Islands">Solomon Islands</option>
                                                <option value="Somalia">Somalia</option>
                                                <option value="South Africa">South Africa</option>
                                                <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                                <option value="Spain">Spain</option>
                                                <option value="Sri Lanka">Sri Lanka</option>
                                                <option value="Sudan">Sudan</option>
                                                <option value="Suriname">Suriname</option>
                                                <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                                <option value="Swaziland">Swaziland</option>
                                                <option value="Sweden">Sweden</option>
                                                <option value="Switzerland">Switzerland</option>
                                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                                <option value="Taiwan">Taiwan</option>
                                                <option value="Tajikistan">Tajikistan</option>
                                                <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                                <option value="Thailand">Thailand</option>
                                                <option value="Timor-leste">Timor-leste</option>
                                                <option value="Togo">Togo</option>
                                                <option value="Tokelau">Tokelau</option>
                                                <option value="Tonga">Tonga</option>
                                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                                <option value="Tunisia">Tunisia</option>
                                                <option value="Turkey">Turkey</option>
                                                <option value="Turkmenistan">Turkmenistan</option>
                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                                <option value="Tuvalu">Tuvalu</option>
                                                <option value="Uganda">Uganda</option>
                                                <option value="Ukraine">Ukraine</option>
                                                <option value="United Arab Emirates">United Arab Emirates</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="United States">United States</option>
                                                <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Uzbekistan">Uzbekistan</option>
                                                <option value="Vanuatu">Vanuatu</option>
                                                <option value="Venezuela">Venezuela</option>
                                                <option value="Viet Nam">Viet Nam</option>
                                                <option value="Virgin Islands, British">Virgin Islands, British</option>
                                                <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                                <option value="Wallis and Futuna">Wallis and Futuna</option>
                                                <option value="Western Sahara">Western Sahara</option>
                                                <option value="Yemen">Yemen</option>
                                                <option value="Zambia">Zambia</option>
                                                <option value="Zimbabwe">Zimbabwe</option>
                                            </select>

                                        </div>
                                        <small>Click on the tag to delete it</small>

                                        {loading ?
                                            <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary disabled" aria-disabled="true"><div className="text-center">
                                                <div className="spinner-border" role="status">
                                                </div>
                                            </div></button> : <>
                                                {/* <button onClick={handleSubmit} style={{ marginTop: "10px" }} className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">
                                                    Submit
                                                </button> */}
                                                <button onClick={handleManualSubmit} style={{ marginTop: "10px" }} className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">
                                                    submit
                                                </button></>
                                        }
                                    </form>

                                    {/* <small className=''> If the automatic approval process takes too long or you get an error, approve it manually by pressing manuel submit.</small> */}
                                    <small className=''> Your social media account will be approved in a short time. If you think there is an error, contact us.</small>

                                    <div className="container mt-3" style={{ backgroundColor: "#F8D7DA", borderRadius: "10px" }}>
                                        <div className="row">
                                            <div className="col text-center  p-3 d-flex align-items-center justify-content-between">
                                                <span ref={textRef}>{`partnerli.com/${user.username}`}</span>
                                                <button className="btn btn-primary ms-2" onClick={handleCopy}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-copy"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                                        />
                                                    </svg>{" "}
                                                    Copy
                                                </button>
                                            </div>
                                            <p>In order for us to verify your social media accounts and for other users to find you, you must specify your affiliate link in the bio or link sections of your social media account.</p>

                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>)
    }

    const deletePP = async () => {
        try {
            const res = await api.delete(`api/save_pp/`);

            if (res.status === 200) {
                setUser(prevUser => ({
                    ...prevUser,
                    profile_picture: `${apiEndpoint}//media/icons/nonpp.png`
                }));
            }
        }
        catch (error) {
        }
    }
    // "http://127.0.0.1:8080/media/icons/nonpp.png"

    function AddLink() {
        const { setUser } = useContext(UserContext);
        const [errors, setErrors] = useState([]);
        const [show, setShow] = useState(false);
        const [loading, setLoading] = useState(false)
        const [link, setLink] = useState("");
        const [text, setText] = useState("");


        const handleShow = () => {
            setShow(true);
        };

        const handleClose = () => {
            setLink("");
            setText("");
            setErrors([]);
            setShow(false);
        }

        const handleSubmit = async (e) => {
            e.preventDefault();
            try {
                setLoading(true);
                const res = await api.post('api/linkview/', { link, text });
                if (res.status === 200) {
                    setUser(prevUser => ({
                        ...prevUser,
                        links: [...prevUser.links, res.data]
                    }));
                }

                handleClose();
            }
            catch (error) {
                setErrors([error.response.data])
                return;
            }
            finally {
                setLoading(false)
            }

        }

        return (<>
            <div className="mt-3">
                <button onClick={handleShow} className="icon-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>
                </button>
            </div>

            {
                show && (
                    <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id="exampleModalLabel">Add link</h1>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit}>

                                        <input className="form-control rounded-3 mb-2"
                                            type="text"
                                            value={link}
                                            onChange={(e) => setLink(e.target.value)}
                                            placeholder="link"
                                            maxLength={254}
                                            required
                                        />
                                        <input className="form-control rounded-3"
                                            type="text"
                                            value={text}
                                            onChange={(e) => setText(e.target.value)}
                                            placeholder="title"
                                            maxLength={254}
                                            required
                                        />

                                        <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                                            {
                                                <ul style={{ padding: "0" }}>
                                                    {errors.map((error, index) => (
                                                        <li key={index}>{` ${error}`}</li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>

                                        {loading ?
                                            <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary disabled" aria-disabled="true"><div className="text-center">
                                                <div className="spinner-border" role="status">
                                                </div>
                                            </div></button> :
                                            <button style={{ marginTop: "10px" }} className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">
                                                Submit
                                            </button>
                                        }
                                    </form>


                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>)
    }

    function ChangePP() {
        const [imageSrc, setImageSrc] = useState(null);
        const [crop, setCrop] = useState({ x: 0, y: 0 });
        const [zoom, setZoom] = useState(1);
        const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

        const handleClose = () => {
            setImageSrc(null);
        }

        const onCropComplete = (croppedArea, croppedAreaPixels) => {
            setCroppedAreaPixels(croppedAreaPixels);
        };

        const handleFileChange = async (e) => {
            const file = e.target.files[0];
            if (file) {
                const imageDataUrl = await readFile(file);
                setImageSrc(imageDataUrl);
            }
        };

        const handleCrop = async () => {
            try {
                const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
                const response = await fetch(croppedImage);
                const blob = await response.blob();

                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async () => {
                    const base64data = reader.result;
                    const res = await api.post('api/save_pp/', { pp: base64data });
                    if (res.status === 200) {
                        setUser(prevUser => ({
                            ...prevUser,
                            profile_picture: res.data
                        }));
                        handleClose();
                    }
                }

            } catch (e) {
                return;
            }
        };

        const readFile = (file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.addEventListener('load', () => resolve(reader.result));
                reader.readAsDataURL(file);
            });
        };

        return (<>

            <div>
                <span className="btn btn-primary btn-file"> Change Profile Picture
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                </span>

                {imageSrc && (

                    <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                {/* <div className="modal-header"><h1 className="modal-title fs-5" id="exampleModalLabel">Change pp</h1></div> */}
                                <div className="modal-body">
                                    <>
                                        <div style={{ position: 'relative', width: '100%', height: 400 }}>
                                            <Cropper
                                                image={imageSrc}
                                                crop={crop}
                                                zoom={zoom}
                                                aspect={3 / 3}
                                                onCropChange={setCrop}
                                                onCropComplete={onCropComplete}
                                                onZoomChange={setZoom}
                                            />
                                        </div>

                                        {/* Zoom Slider */}
                                        <div style={{ marginTop: '1rem' }}>
                                            <label htmlFor="zoomRange" className="form-label">Zoom</label>
                                            <input
                                                id="zoomRange"
                                                type="range"
                                                min={1}
                                                max={3}
                                                step={0.1}
                                                value={zoom}
                                                onChange={(e) => setZoom(parseFloat(e.target.value))}
                                                className="form-range"
                                            />
                                        </div>
                                    </>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" onClick={handleCrop}>Save</button>
                                    <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
        );
    }

    function EditProfile() {
        const { user, setUser } = useContext(UserContext);
        const [bio, setBio] = useState(user.profile_text);
        const [errors, setErrors] = useState([]);
        const [show, setShow] = useState(false);
        const [loading, setLoading] = useState(false);
        const [tags, setTags] = useState(user.profile_tags);
        const [tag, setTag] = useState("");
        const [countrys, setCountrys] = useState(user.profile_countrys);
        const [tagsuggeslist, setSagsuggeslist] = useState([]);
        const [checked, setChecked] = useState(user.is_content_producer);
        const [selectedCountry, setSelectedCountry] = useState("Choose...");

        // const rgbToHex = (rgb) => {
        //     const [r, g, b] = rgb.match(/\d+/g).map(Number);
        //     return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
        // };

        // const [color, setColor] = useState(rgbToHex(user.background_color));

        // const hexToRgb = (hex) => {
        //     let r = parseInt(hex.substring(1, 3), 16);
        //     let g = parseInt(hex.substring(3, 5), 16);
        //     let b = parseInt(hex.substring(5, 7), 16);
        //     return `rgb(${r}, ${g}, ${b})`;
        // };

        const handleCheckboxChange = (event) => {
            setChecked(event.target.checked);
        };

        const setonetag = () => {
            if (!tags.includes(tag)) {
                setTags([...tags, tag]);
            }
            setTag("");
        }

        const handleSetTag = (e) => {
            setTag(e);
            if (e === "") {
                setSagsuggeslist([]);
            } else {
                setTag(e);
            }
        };

        useEffect(() => {
            if (tag === "") {
                setSagsuggeslist([]);
                return;
            }
            setSagsuggeslist(
                user.tags.filter((t) =>
                    t.name.startsWith(tag)
                )
            );
            // eslint-disable-next-line
        }, [tag]);



        const handleShow = () => {
            setShow(true);
        };

        const handleSubmit = async (e) => {
            e.preventDefault();

            if (tags.length > 10) {
                setErrors(["You can only select 10 tags."])
                return;
            }

            try {
                setLoading(true);
                await api.post('api/edit_profile/', { bio, tags, countrys, checked });
                // , background_color: hexToRgb(color)
                setUser(prevUser => ({
                    ...prevUser,
                    profile_text: bio,
                    profile_tags: tags,
                    profile_countrys: countrys,
                    is_content_producer: checked,
                    // background_color: hexToRgb(color)

                }));
                handleClose();
            }
            catch (error) {
                setErrors([error.response.data])
                return;
            }
            finally {
                setLoading(false)
            }

        }

        const handleClose = () => {
            setErrors([]);
            setTag("");
            setShow(false);
        }
        const handleCountryChange = (event) => {
            const selected = event.target.value;

            if (countrys.length === 5) {
                setErrors(["You can only select 5 countries."]);
                return;
            }

            if (selected !== "Choose..." && !countrys.includes(selected)) {
                setCountrys([...countrys, selected]);
            }

            // Seçimi sıfırla
            setSelectedCountry("Choose...");
        };

        return (<>
            <button style={{ fontSize: "18px" }} onClick={handleShow} className="navbtns d-grid gap-2" type="button">
                Edit Profile
            </button>
            {
                show && (
                    <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <ChangePP />
                                    <button type="button" className='btn btn-danger mx-2' onClick={deletePP} >Delete Profile Picture</button>
                                </div>
                                <div className="modal-body">


                                    <form onSubmit={handleSubmit}>

                                        {/* Backround color */}
                                        {/* <h4>Backround color:</h4>
                                        <input
                                            type="color"
                                            value={color}
                                            onChange={(e) => setColor(e.target.value)}
                                        /> */}



                                        {/* bio */}
                                        <h4>Bio text: </h4>
                                        <textarea className="form-control rounded-3"
                                            type="text"
                                            value={bio}
                                            onChange={(e) => setBio(e.target.value)}
                                            placeholder="bio"
                                            maxLength={500} />
                                        <small>We recommend that you make it short and understandable.</small>


                                        {/* errors */}
                                        <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                                            {
                                                <ul style={{ padding: "0" }}>
                                                    {errors.map((error, index) => (
                                                        <li key={index}>{` ${error}`}</li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>

                                        {/* tags */}
                                        <h4>Tags: </h4>
                                        <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                            {
                                                tags.map((tag, index) => (
                                                    <span key={index} onClick={() => setTags(tags.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{tag}</span>
                                                ))}

                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    value={tag}
                                                    onChange={(e) => handleSetTag(e.target.value)}
                                                    placeholder="Tag"
                                                    maxLength={254}
                                                />
                                                <ul className="dropdown-menu" >
                                                    {tagsuggeslist.map((tag, index) => (
                                                        // eslint-disable-next-line
                                                        <li key={index}><a className="dropdown-item" onClick={() => setTag(tag.name)}>{tag.name}</a></li>
                                                    ))}
                                                </ul>


                                                <button onClick={() => { if (tag === "") { return } setonetag() }} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                            </div>

                                        </div>
                                        <small>Click on the tag to delete it</small>

                                        {/* community locations */}
                                        <h4 className=' py-3'>Community locations: </h4>
                                        <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                            {countrys.map((country, index) => (
                                                <span key={index} onClick={() => setCountrys(countrys.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{country}</span>
                                            ))}
                                            <select id="country" name="country" className="form-control" value={selectedCountry} onChange={handleCountryChange}>

                                                {/* <select id="country" name="country" className="form-control" onChange={handleCountryChange}> */}
                                                <option defaultValue={"Choose..."}></option>
                                                <option value="Global">Global</option>

                                                <option value="Afghanistan">Afghanistan</option>
                                                <option value="Åland Islands">Åland Islands</option>
                                                <option value="Albania">Albania</option>
                                                <option value="Algeria">Algeria</option>
                                                <option value="American Samoa">American Samoa</option>
                                                <option value="Andorra">Andorra</option>
                                                <option value="Angola">Angola</option>
                                                <option value="Anguilla">Anguilla</option>
                                                <option value="Antarctica">Antarctica</option>
                                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Armenia">Armenia</option>
                                                <option value="Aruba">Aruba</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Austria">Austria</option>
                                                <option value="Azerbaijan">Azerbaijan</option>
                                                <option value="Bahamas">Bahamas</option>
                                                <option value="Bahrain">Bahrain</option>
                                                <option value="Bangladesh">Bangladesh</option>
                                                <option value="Barbados">Barbados</option>
                                                <option value="Belarus">Belarus</option>
                                                <option value="Belgium">Belgium</option>
                                                <option value="Belize">Belize</option>
                                                <option value="Benin">Benin</option>
                                                <option value="Bermuda">Bermuda</option>
                                                <option value="Bhutan">Bhutan</option>
                                                <option value="Bolivia">Bolivia</option>
                                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                                <option value="Botswana">Botswana</option>
                                                <option value="Bouvet Island">Bouvet Island</option>
                                                <option value="Brazil">Brazil</option>
                                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                                <option value="Bulgaria">Bulgaria</option>
                                                <option value="Burkina Faso">Burkina Faso</option>
                                                <option value="Burundi">Burundi</option>
                                                <option value="Cambodia">Cambodia</option>
                                                <option value="Cameroon">Cameroon</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Cape Verde">Cape Verde</option>
                                                <option value="Cayman Islands">Cayman Islands</option>
                                                <option value="Central African Republic">Central African Republic</option>
                                                <option value="Chad">Chad</option>
                                                <option value="Chile">Chile</option>
                                                <option value="China">China</option>
                                                <option value="Christmas Island">Christmas Island</option>
                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Comoros">Comoros</option>
                                                <option value="Congo">Congo</option>
                                                <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                                <option value="Cook Islands">Cook Islands</option>
                                                <option value="Costa Rica">Costa Rica</option>
                                                <option value="Cote D'ivoire">Cote D'ivoire</option>
                                                <option value="Croatia">Croatia</option>
                                                <option value="Cuba">Cuba</option>
                                                <option value="Cyprus">Cyprus</option>
                                                <option value="Czech Republic">Czech Republic</option>
                                                <option value="Denmark">Denmark</option>
                                                <option value="Djibouti">Djibouti</option>
                                                <option value="Dominica">Dominica</option>
                                                <option value="Dominican Republic">Dominican Republic</option>
                                                <option value="Ecuador">Ecuador</option>
                                                <option value="Egypt">Egypt</option>
                                                <option value="El Salvador">El Salvador</option>
                                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                                <option value="Eritrea">Eritrea</option>
                                                <option value="Estonia">Estonia</option>
                                                <option value="Ethiopia">Ethiopia</option>
                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                                <option value="Faroe Islands">Faroe Islands</option>
                                                <option value="Fiji">Fiji</option>
                                                <option value="Finland">Finland</option>
                                                <option value="France">France</option>
                                                <option value="French Guiana">French Guiana</option>
                                                <option value="French Polynesia">French Polynesia</option>
                                                <option value="French Southern Territories">French Southern Territories</option>
                                                <option value="Gabon">Gabon</option>
                                                <option value="Gambia">Gambia</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Germany">Germany</option>
                                                <option value="Ghana">Ghana</option>
                                                <option value="Gibraltar">Gibraltar</option>
                                                <option value="Greece">Greece</option>
                                                <option value="Greenland">Greenland</option>
                                                <option value="Grenada">Grenada</option>
                                                <option value="Guadeloupe">Guadeloupe</option>
                                                <option value="Guam">Guam</option>
                                                <option value="Guatemala">Guatemala</option>
                                                <option value="Guernsey">Guernsey</option>
                                                <option value="Guinea">Guinea</option>
                                                <option value="Guinea-bissau">Guinea-bissau</option>
                                                <option value="Guyana">Guyana</option>
                                                <option value="Haiti">Haiti</option>
                                                <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                                <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                                <option value="Honduras">Honduras</option>
                                                <option value="Hong Kong">Hong Kong</option>
                                                <option value="Hungary">Hungary</option>
                                                <option value="Iceland">Iceland</option>
                                                <option value="India">India</option>
                                                <option value="Indonesia">Indonesia</option>
                                                <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                                <option value="Iraq">Iraq</option>
                                                <option value="Ireland">Ireland</option>
                                                <option value="Isle of Man">Isle of Man</option>
                                                <option value="Israel">Israel</option>
                                                <option value="Italy">Italy</option>
                                                <option value="Jamaica">Jamaica</option>
                                                <option value="Japan">Japan</option>
                                                <option value="Jersey">Jersey</option>
                                                <option value="Jordan">Jordan</option>
                                                <option value="Kazakhstan">Kazakhstan</option>
                                                <option value="Kenya">Kenya</option>
                                                <option value="Kiribati">Kiribati</option>
                                                <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                                <option value="Korea, Republic of">Korea, Republic of</option>
                                                <option value="Kuwait">Kuwait</option>
                                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                <option value="Latvia">Latvia</option>
                                                <option value="Lebanon">Lebanon</option>
                                                <option value="Lesotho">Lesotho</option>
                                                <option value="Liberia">Liberia</option>
                                                <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                                <option value="Liechtenstein">Liechtenstein</option>
                                                <option value="Lithuania">Lithuania</option>
                                                <option value="Luxembourg">Luxembourg</option>
                                                <option value="Macao">Macao</option>
                                                <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                                <option value="Madagascar">Madagascar</option>
                                                <option value="Malawi">Malawi</option>
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="Maldives">Maldives</option>
                                                <option value="Mali">Mali</option>
                                                <option value="Malta">Malta</option>
                                                <option value="Marshall Islands">Marshall Islands</option>
                                                <option value="Martinique">Martinique</option>
                                                <option value="Mauritania">Mauritania</option>
                                                <option value="Mauritius">Mauritius</option>
                                                <option value="Mayotte">Mayotte</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                                <option value="Moldova, Republic of">Moldova, Republic of</option>
                                                <option value="Monaco">Monaco</option>
                                                <option value="Mongolia">Mongolia</option>
                                                <option value="Montenegro">Montenegro</option>
                                                <option value="Montserrat">Montserrat</option>
                                                <option value="Morocco">Morocco</option>
                                                <option value="Mozambique">Mozambique</option>
                                                <option value="Myanmar">Myanmar</option>
                                                <option value="Namibia">Namibia</option>
                                                <option value="Nauru">Nauru</option>
                                                <option value="Nepal">Nepal</option>
                                                <option value="Netherlands">Netherlands</option>
                                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                                <option value="New Caledonia">New Caledonia</option>
                                                <option value="New Zealand">New Zealand</option>
                                                <option value="Nicaragua">Nicaragua</option>
                                                <option value="Niger">Niger</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="Niue">Niue</option>
                                                <option value="Norfolk Island">Norfolk Island</option>
                                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                <option value="Norway">Norway</option>
                                                <option value="Oman">Oman</option>
                                                <option value="Pakistan">Pakistan</option>
                                                <option value="Palau">Palau</option>
                                                <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                                <option value="Panama">Panama</option>
                                                <option value="Papua New Guinea">Papua New Guinea</option>
                                                <option value="Paraguay">Paraguay</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Philippines">Philippines</option>
                                                <option value="Pitcairn">Pitcairn</option>
                                                <option value="Poland">Poland</option>
                                                <option value="Portugal">Portugal</option>
                                                <option value="Puerto Rico">Puerto Rico</option>
                                                <option value="Qatar">Qatar</option>
                                                <option value="Reunion">Reunion</option>
                                                <option value="Romania">Romania</option>
                                                <option value="Russian Federation">Russian Federation</option>
                                                <option value="Rwanda">Rwanda</option>
                                                <option value="Saint Helena">Saint Helena</option>
                                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                                <option value="Saint Lucia">Saint Lucia</option>
                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                                <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                                <option value="Samoa">Samoa</option>
                                                <option value="San Marino">San Marino</option>
                                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                                <option value="Saudi Arabia">Saudi Arabia</option>
                                                <option value="Senegal">Senegal</option>
                                                <option value="Serbia">Serbia</option>
                                                <option value="Seychelles">Seychelles</option>
                                                <option value="Sierra Leone">Sierra Leone</option>
                                                <option value="Singapore">Singapore</option>
                                                <option value="Slovakia">Slovakia</option>
                                                <option value="Slovenia">Slovenia</option>
                                                <option value="Solomon Islands">Solomon Islands</option>
                                                <option value="Somalia">Somalia</option>
                                                <option value="South Africa">South Africa</option>
                                                <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                                <option value="Spain">Spain</option>
                                                <option value="Sri Lanka">Sri Lanka</option>
                                                <option value="Sudan">Sudan</option>
                                                <option value="Suriname">Suriname</option>
                                                <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                                <option value="Swaziland">Swaziland</option>
                                                <option value="Sweden">Sweden</option>
                                                <option value="Switzerland">Switzerland</option>
                                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                                <option value="Taiwan">Taiwan</option>
                                                <option value="Tajikistan">Tajikistan</option>
                                                <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                                <option value="Thailand">Thailand</option>
                                                <option value="Timor-leste">Timor-leste</option>
                                                <option value="Togo">Togo</option>
                                                <option value="Tokelau">Tokelau</option>
                                                <option value="Tonga">Tonga</option>
                                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                                <option value="Tunisia">Tunisia</option>
                                                <option value="Turkey">Turkey</option>
                                                <option value="Turkmenistan">Turkmenistan</option>
                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                                <option value="Tuvalu">Tuvalu</option>
                                                <option value="Uganda">Uganda</option>
                                                <option value="Ukraine">Ukraine</option>
                                                <option value="United Arab Emirates">United Arab Emirates</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="United States">United States</option>
                                                <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Uzbekistan">Uzbekistan</option>
                                                <option value="Vanuatu">Vanuatu</option>
                                                <option value="Venezuela">Venezuela</option>
                                                <option value="Viet Nam">Viet Nam</option>
                                                <option value="Virgin Islands, British">Virgin Islands, British</option>
                                                <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                                <option value="Wallis and Futuna">Wallis and Futuna</option>
                                                <option value="Western Sahara">Western Sahara</option>
                                                <option value="Yemen">Yemen</option>
                                                <option value="Zambia">Zambia</option>
                                                <option value="Zimbabwe">Zimbabwe</option>
                                            </select>
                                        </div>
                                        <small>Click on the tag to delete it</small>

                                        {/* check box */}
                                        <div style={{ padding: "15px" }} className="d-flex gap-2 justify-content-right py-1 flex-wrap ">
                                            <div className="form-check form-switch">
                                                <input
                                                    checked={checked}
                                                    onChange={handleCheckboxChange}
                                                    style={{ fontSize: "20px" }}
                                                    className="form-check-input custom-checkbox"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                />
                                                <label style={{ marginLeft: "15px", marginTop: "3px", marginRight: "5px" }} className="form-check-label" htmlFor="flexSwitchCheckDefault">I am content creator</label>

                                                ( <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="#49AFFE"
                                                    viewBox="0 0 16 16"
                                                // style={{
                                                //     position: "absolute",
                                                //     bottom: "0px",
                                                //     right: "0px",
                                                //     transform: "translate(30%, 30%)", // biraz üstüne gelsin diye
                                                //     backgroundColor: "white",

                                                //     padding: "2px"
                                                // }}
                                                >
                                                    <path d="M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                                                    <path d="M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM1 3a1 1 0 0 1 1-1h2v2H1zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3zm-4-2h3v2H2a1 1 0 0 1-1-1zm3-1H1V8h3zm0-3H1V5h3z" />
                                                </svg> )
                                            </div>
                                        </div>

                                        {loading ?
                                            <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary disabled" aria-disabled="true"><div className="text-center">
                                                <div className="spinner-border" role="status">
                                                </div>
                                            </div></button> :
                                            <button style={{ marginTop: "10px" }} className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">
                                                Submit
                                            </button>
                                        }
                                    </form>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                        <style>
                            {`
          .custom-checkbox {
            transform: scale(1.3); /* Büyüklük ayarı */
            margin-left: 60px; /* İsteğe bağlı boşluk */
          }
        `}
                        </style>
                    </div>
                )}
        </>)
    }

    function ChangeVisibility() {
        const [loading, setLoading] = useState(false);

        const handleVisibility = async () => {

            try {
                setLoading(true);
                const res = await api.post('/api/change_visibility/');
                if (res.status === 200) {
                    setUser(prevUser => ({
                        ...prevUser,
                        is_active: res.data[0]
                    }));
                }
            }
            catch (error) {
            }
            finally {
                setLoading(false);
            }
        }

        if (loading) {
            return (<>
                <span style={{ marginTop: "10px" }} type="button" className="btn btn-secondary" > <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div></span>
            </>)
        }
        return (<>
            {user.is_active ? <>
                <span style={{ marginTop: "10px" }} type="button" onClick={handleVisibility} className="btn btn-success"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                </svg></span>
                <small style={{ maxWidth: "300px", marginBottom: "20px" }}>Your account visible. If you do not want your account to be visible, you can close it.</small>
            </>
                : <>
                    <span style={{ marginTop: "10px" }} type="button" onClick={handleVisibility} className="btn btn-danger"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                    </svg></span>
                    <small style={{ maxWidth: "300px", marginBottom: "20px" }}>Your account not visible. You need to turn on visibility htmlFor people to see your profile.</small>
                </>
            }
        </ >)
    }

    function UpdateSocialMedia() {
        const { user, setUser } = useContext(UserContext);
        const [socialMedia] = useState("");
        const [errors, setErrors] = useState([]);
        const [loading, setLoading] = useState(false);

        const [tags, setTags] = useState(user.socials.find((social) => social.id === updateid)?.tags.map((tag) => tag.name) || []);
        const [tag, setTag] = useState("");
        const [countrys, setCountrys] = useState(user.socials.find((social) => social.id === updateid)?.countrys.map((countrys) => countrys.name) || []);
        const [tagsuggeslist, setSagsuggeslist] = useState([]);
        const [selectedCountry, setSelectedCountry] = useState("Choose...");


        const handleSetTag = (e) => {
            setTag(e);
            if (e === "") {
                setSagsuggeslist([]);
            } else {
                setTag(e);
            }
        };
        const setonetag = () => {
            if (!tags.includes(tag)) {
                setTags([...tags, tag]);
            }
            setTag("");
        }
        useEffect(() => {
            if (tag === "") {
                setSagsuggeslist([]);
                return;
            }
            setSagsuggeslist(
                user.tags.filter((t) =>
                    t.name.startsWith(tag)
                )
            );
            // eslint-disable-next-line
        }, [tag]);

        const handleCountryChange = (event) => {
            const selected = event.target.value;

            if (countrys.length === 5) {
                setErrors(["You can only select 5 countries."]);
                return;
            }

            if (selected !== "Choose..." && !countrys.includes(selected)) {
                setCountrys([...countrys, selected]);
            }

            // Seçimi sıfırla
            setSelectedCountry("Choose...");
        };

        const handleSubmit = async (e) => {
            e.preventDefault();

            if (tags.length > 10) {
                setErrors(["You can only select 10 tags."])
                return;
            }
            try {
                setLoading(true);

                const res = await api.put('api/social_media/', { updateid, tags, countrys });

                if (res.status === 200 && !(user.socials.some(social => social.social_media === socialMedia))) {
                    setUser((prevUser) => ({
                        ...prevUser,
                        socials: prevUser.socials.map((social) =>
                            social.id === res.data.id ? res.data : social
                        ),
                    }));
                }
                handleClose();
            }
            catch (error) {
                setErrors([error.response.data])
                return;
            }
            finally {
                setLoading(false)
            }
        }
        const handleClose = () => {
            setErrors([]);
            setTags([]);
            setTag("");
            updatehandleclose();

        }

        if (updateshow === true) {

            return (<>

                <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="exampleModalLabel">Update Social Media</h1>
                            </div>
                            <div className="modal-body">


                                <form onSubmit={handleSubmit}>

                                    <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                                        {
                                            <ul style={{ padding: "0" }}>
                                                {errors.map((error, index) => (
                                                    <li key={index}>{` ${error}`}</li>
                                                ))}
                                            </ul>
                                        }
                                    </div>

                                    <h4>Tags: </h4>
                                    <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                        {
                                            tags.map((tag, index) => (
                                                <span key={index} onClick={() => setTags(tags.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{tag}</span>
                                            ))}

                                        <div className="input-group mb-3">
                                            <input
                                                type="text"
                                                className="form-control dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                value={tag}
                                                onChange={(e) => handleSetTag(e.target.value)}
                                                placeholder="Tag"
                                                maxLength={254}
                                            />
                                            <ul className="dropdown-menu" >
                                                {tagsuggeslist.map((tag, index) => (
                                                    // eslint-disable-next-line
                                                    <li key={index}><a className="dropdown-item" onClick={() => setTag(tag.name)}>{tag.name}</a></li>
                                                ))}
                                            </ul>

                                            <button onClick={() => { if (tag === "") { return } setonetag() }} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                        </div>

                                    </div>
                                    <small>Click on the tag to delete it</small>

                                    <h4 className=' py-3'>Community locations: </h4>
                                    <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                        {countrys.map((country, index) => (
                                            <span key={index} onClick={() => setCountrys(countrys.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{country}</span>
                                        ))}
                                        <select id="country" name="country" className="form-control" value={selectedCountry} onChange={handleCountryChange}>

                                            <option defaultValue={"Choose..."}></option>
                                            <option value="Global">Global</option>

                                            <option value="Afghanistan">Afghanistan</option>
                                            <option value="Åland Islands">Åland Islands</option>
                                            <option value="Albania">Albania</option>
                                            <option value="Algeria">Algeria</option>
                                            <option value="American Samoa">American Samoa</option>
                                            <option value="Andorra">Andorra</option>
                                            <option value="Angola">Angola</option>
                                            <option value="Anguilla">Anguilla</option>
                                            <option value="Antarctica">Antarctica</option>
                                            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                            <option value="Argentina">Argentina</option>
                                            <option value="Armenia">Armenia</option>
                                            <option value="Aruba">Aruba</option>
                                            <option value="Australia">Australia</option>
                                            <option value="Austria">Austria</option>
                                            <option value="Azerbaijan">Azerbaijan</option>
                                            <option value="Bahamas">Bahamas</option>
                                            <option value="Bahrain">Bahrain</option>
                                            <option value="Bangladesh">Bangladesh</option>
                                            <option value="Barbados">Barbados</option>
                                            <option value="Belarus">Belarus</option>
                                            <option value="Belgium">Belgium</option>
                                            <option value="Belize">Belize</option>
                                            <option value="Benin">Benin</option>
                                            <option value="Bermuda">Bermuda</option>
                                            <option value="Bhutan">Bhutan</option>
                                            <option value="Bolivia">Bolivia</option>
                                            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                            <option value="Botswana">Botswana</option>
                                            <option value="Bouvet Island">Bouvet Island</option>
                                            <option value="Brazil">Brazil</option>
                                            <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                            <option value="Brunei Darussalam">Brunei Darussalam</option>
                                            <option value="Bulgaria">Bulgaria</option>
                                            <option value="Burkina Faso">Burkina Faso</option>
                                            <option value="Burundi">Burundi</option>
                                            <option value="Cambodia">Cambodia</option>
                                            <option value="Cameroon">Cameroon</option>
                                            <option value="Canada">Canada</option>
                                            <option value="Cape Verde">Cape Verde</option>
                                            <option value="Cayman Islands">Cayman Islands</option>
                                            <option value="Central African Republic">Central African Republic</option>
                                            <option value="Chad">Chad</option>
                                            <option value="Chile">Chile</option>
                                            <option value="China">China</option>
                                            <option value="Christmas Island">Christmas Island</option>
                                            <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                            <option value="Colombia">Colombia</option>
                                            <option value="Comoros">Comoros</option>
                                            <option value="Congo">Congo</option>
                                            <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                            <option value="Cook Islands">Cook Islands</option>
                                            <option value="Costa Rica">Costa Rica</option>
                                            <option value="Cote D'ivoire">Cote D'ivoire</option>
                                            <option value="Croatia">Croatia</option>
                                            <option value="Cuba">Cuba</option>
                                            <option value="Cyprus">Cyprus</option>
                                            <option value="Czech Republic">Czech Republic</option>
                                            <option value="Denmark">Denmark</option>
                                            <option value="Djibouti">Djibouti</option>
                                            <option value="Dominica">Dominica</option>
                                            <option value="Dominican Republic">Dominican Republic</option>
                                            <option value="Ecuador">Ecuador</option>
                                            <option value="Egypt">Egypt</option>
                                            <option value="El Salvador">El Salvador</option>
                                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                                            <option value="Eritrea">Eritrea</option>
                                            <option value="Estonia">Estonia</option>
                                            <option value="Ethiopia">Ethiopia</option>
                                            <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                            <option value="Faroe Islands">Faroe Islands</option>
                                            <option value="Fiji">Fiji</option>
                                            <option value="Finland">Finland</option>
                                            <option value="France">France</option>
                                            <option value="French Guiana">French Guiana</option>
                                            <option value="French Polynesia">French Polynesia</option>
                                            <option value="French Southern Territories">French Southern Territories</option>
                                            <option value="Gabon">Gabon</option>
                                            <option value="Gambia">Gambia</option>
                                            <option value="Georgia">Georgia</option>
                                            <option value="Germany">Germany</option>
                                            <option value="Ghana">Ghana</option>
                                            <option value="Gibraltar">Gibraltar</option>
                                            <option value="Greece">Greece</option>
                                            <option value="Greenland">Greenland</option>
                                            <option value="Grenada">Grenada</option>
                                            <option value="Guadeloupe">Guadeloupe</option>
                                            <option value="Guam">Guam</option>
                                            <option value="Guatemala">Guatemala</option>
                                            <option value="Guernsey">Guernsey</option>
                                            <option value="Guinea">Guinea</option>
                                            <option value="Guinea-bissau">Guinea-bissau</option>
                                            <option value="Guyana">Guyana</option>
                                            <option value="Haiti">Haiti</option>
                                            <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                            <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                            <option value="Honduras">Honduras</option>
                                            <option value="Hong Kong">Hong Kong</option>
                                            <option value="Hungary">Hungary</option>
                                            <option value="Iceland">Iceland</option>
                                            <option value="India">India</option>
                                            <option value="Indonesia">Indonesia</option>
                                            <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                            <option value="Iraq">Iraq</option>
                                            <option value="Ireland">Ireland</option>
                                            <option value="Isle of Man">Isle of Man</option>
                                            <option value="Israel">Israel</option>
                                            <option value="Italy">Italy</option>
                                            <option value="Jamaica">Jamaica</option>
                                            <option value="Japan">Japan</option>
                                            <option value="Jersey">Jersey</option>
                                            <option value="Jordan">Jordan</option>
                                            <option value="Kazakhstan">Kazakhstan</option>
                                            <option value="Kenya">Kenya</option>
                                            <option value="Kiribati">Kiribati</option>
                                            <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                            <option value="Korea, Republic of">Korea, Republic of</option>
                                            <option value="Kuwait">Kuwait</option>
                                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                                            <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                            <option value="Latvia">Latvia</option>
                                            <option value="Lebanon">Lebanon</option>
                                            <option value="Lesotho">Lesotho</option>
                                            <option value="Liberia">Liberia</option>
                                            <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                            <option value="Liechtenstein">Liechtenstein</option>
                                            <option value="Lithuania">Lithuania</option>
                                            <option value="Luxembourg">Luxembourg</option>
                                            <option value="Macao">Macao</option>
                                            <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                            <option value="Madagascar">Madagascar</option>
                                            <option value="Malawi">Malawi</option>
                                            <option value="Malaysia">Malaysia</option>
                                            <option value="Maldives">Maldives</option>
                                            <option value="Mali">Mali</option>
                                            <option value="Malta">Malta</option>
                                            <option value="Marshall Islands">Marshall Islands</option>
                                            <option value="Martinique">Martinique</option>
                                            <option value="Mauritania">Mauritania</option>
                                            <option value="Mauritius">Mauritius</option>
                                            <option value="Mayotte">Mayotte</option>
                                            <option value="Mexico">Mexico</option>
                                            <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                            <option value="Moldova, Republic of">Moldova, Republic of</option>
                                            <option value="Monaco">Monaco</option>
                                            <option value="Mongolia">Mongolia</option>
                                            <option value="Montenegro">Montenegro</option>
                                            <option value="Montserrat">Montserrat</option>
                                            <option value="Morocco">Morocco</option>
                                            <option value="Mozambique">Mozambique</option>
                                            <option value="Myanmar">Myanmar</option>
                                            <option value="Namibia">Namibia</option>
                                            <option value="Nauru">Nauru</option>
                                            <option value="Nepal">Nepal</option>
                                            <option value="Netherlands">Netherlands</option>
                                            <option value="Netherlands Antilles">Netherlands Antilles</option>
                                            <option value="New Caledonia">New Caledonia</option>
                                            <option value="New Zealand">New Zealand</option>
                                            <option value="Nicaragua">Nicaragua</option>
                                            <option value="Niger">Niger</option>
                                            <option value="Nigeria">Nigeria</option>
                                            <option value="Niue">Niue</option>
                                            <option value="Norfolk Island">Norfolk Island</option>
                                            <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                            <option value="Norway">Norway</option>
                                            <option value="Oman">Oman</option>
                                            <option value="Pakistan">Pakistan</option>
                                            <option value="Palau">Palau</option>
                                            <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                            <option value="Panama">Panama</option>
                                            <option value="Papua New Guinea">Papua New Guinea</option>
                                            <option value="Paraguay">Paraguay</option>
                                            <option value="Peru">Peru</option>
                                            <option value="Philippines">Philippines</option>
                                            <option value="Pitcairn">Pitcairn</option>
                                            <option value="Poland">Poland</option>
                                            <option value="Portugal">Portugal</option>
                                            <option value="Puerto Rico">Puerto Rico</option>
                                            <option value="Qatar">Qatar</option>
                                            <option value="Reunion">Reunion</option>
                                            <option value="Romania">Romania</option>
                                            <option value="Russian Federation">Russian Federation</option>
                                            <option value="Rwanda">Rwanda</option>
                                            <option value="Saint Helena">Saint Helena</option>
                                            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                            <option value="Saint Lucia">Saint Lucia</option>
                                            <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                            <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                            <option value="Samoa">Samoa</option>
                                            <option value="San Marino">San Marino</option>
                                            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                            <option value="Saudi Arabia">Saudi Arabia</option>
                                            <option value="Senegal">Senegal</option>
                                            <option value="Serbia">Serbia</option>
                                            <option value="Seychelles">Seychelles</option>
                                            <option value="Sierra Leone">Sierra Leone</option>
                                            <option value="Singapore">Singapore</option>
                                            <option value="Slovakia">Slovakia</option>
                                            <option value="Slovenia">Slovenia</option>
                                            <option value="Solomon Islands">Solomon Islands</option>
                                            <option value="Somalia">Somalia</option>
                                            <option value="South Africa">South Africa</option>
                                            <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                            <option value="Spain">Spain</option>
                                            <option value="Sri Lanka">Sri Lanka</option>
                                            <option value="Sudan">Sudan</option>
                                            <option value="Suriname">Suriname</option>
                                            <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                            <option value="Swaziland">Swaziland</option>
                                            <option value="Sweden">Sweden</option>
                                            <option value="Switzerland">Switzerland</option>
                                            <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                            <option value="Taiwan">Taiwan</option>
                                            <option value="Tajikistan">Tajikistan</option>
                                            <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                            <option value="Thailand">Thailand</option>
                                            <option value="Timor-leste">Timor-leste</option>
                                            <option value="Togo">Togo</option>
                                            <option value="Tokelau">Tokelau</option>
                                            <option value="Tonga">Tonga</option>
                                            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                            <option value="Tunisia">Tunisia</option>
                                            <option value="Turkey">Turkey</option>
                                            <option value="Turkmenistan">Turkmenistan</option>
                                            <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                            <option value="Tuvalu">Tuvalu</option>
                                            <option value="Uganda">Uganda</option>
                                            <option value="Ukraine">Ukraine</option>
                                            <option value="United Arab Emirates">United Arab Emirates</option>
                                            <option value="United Kingdom">United Kingdom</option>
                                            <option value="United States">United States</option>
                                            <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                            <option value="Uruguay">Uruguay</option>
                                            <option value="Uzbekistan">Uzbekistan</option>
                                            <option value="Vanuatu">Vanuatu</option>
                                            <option value="Venezuela">Venezuela</option>
                                            <option value="Viet Nam">Viet Nam</option>
                                            <option value="Virgin Islands, British">Virgin Islands, British</option>
                                            <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                            <option value="Wallis and Futuna">Wallis and Futuna</option>
                                            <option value="Western Sahara">Western Sahara</option>
                                            <option value="Yemen">Yemen</option>
                                            <option value="Zambia">Zambia</option>
                                            <option value="Zimbabwe">Zimbabwe</option>
                                        </select>

                                    </div>
                                    <small>Click on the tag to delete it</small>

                                    {loading ?
                                        <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary disabled" aria-disabled="true"><div className="text-center">
                                            <div className="spinner-border" role="status">
                                            </div>
                                        </div></button> :
                                        <button style={{ marginTop: "10px" }} className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">
                                            Submit
                                        </button>
                                    }
                                </form>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

            </>)
        }
        else {
            return (<></>)

        }
    }

    function RenderSocials() {
        return (<>
            {user.socials.map((item, index) => (
                <div key={index} className='container mt-4'>
                    <div className='d-flex justify-content-between align-items-center '>

                        <div onClick={() => window.open(item.link, "_blank")} className={`p-2 container  centered-div ${item.social_media}`}>
                            <div className="d-flex align-items-center position-relative">
                                <img src={`${apiEndpoint}/media/icons/${item.social_media}.png`} alt="Profil Fotoğrafı" className="profile-pic me-3" />

                                <div className="container">

                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                                            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                                        </svg> : {item.followers}
                                    </p>


                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                                            <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                                        </svg> :

                                        {item.countrys.map((country, countryIndex) => (
                                            <span className="countrys" key={countryIndex}> {country.name} </span>
                                        ))}
                                    </p>

                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                                            <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                                            <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                                        </svg> :

                                        {item.tags.map((country, countryIndex) => (
                                            <span className="tags" key={countryIndex}> {country.name} </span>
                                        ))}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: "50px", paddingLeft: "10px" }}>

                            <button
                                onClick={() => { deleteSocial(item.id) }}
                                className="btn btn-outline-danger rounded-circle m-1"
                                style={{ width: '40px', height: '40px' }}
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                </svg>
                            </button>
                            <button
                                onClick={() => { handleshow(item.id) }}
                                className="btn btn-outline-secondary rounded-circle m-1"
                                style={{ width: '40px', height: '40px' }}
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                </svg>
                            </button>
                        </div>

                    </div>
                </div>
            ))}
        </>
        )
    }

    function RenderManuelSocials() {
        return (<>
            {user.manule_socials && user.manule_socials.length > 0 && (
                <h4 className="fw-bold mt-5 mb-0 pb-2 manver">In verification:</h4>
            )}

            {user.manule_socials.map((item, index) => (
                <div key={index} className='container mt-4'>
                    <div className='d-flex justify-content-between align-items-center '>
                        <div className={`p-2 container  centered-div ${item.social_media}`}>
                            <div className="d-flex align-items-center position-relative">
                                <img src={`${apiEndpoint}/media/icons/${item.social_media}.png`} alt="Profil Fotoğrafı" className="profile-pic me-3" />
                                <div className="container">

                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                                            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                                        </svg> : ---
                                    </p>


                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                                            <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                                        </svg> :

                                        {item.countrys.map((country, countryIndex) => (
                                            <span className="countrys" key={countryIndex}> {country.name} </span>
                                        ))}
                                    </p>

                                    <p style={{ marginBottom: "0" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                                            <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                                            <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                                        </svg> :

                                        {item.tags.map((country, countryIndex) => (
                                            <span className="tags" key={countryIndex}> {country.name} </span>
                                        ))}
                                    </p>


                                </div>
                            </div>
                        </div>
                        <div style={{ width: "50px", paddingLeft: "10px" }}>
                            <button
                                onClick={() => { deleteManuelSocial(item.id) }}
                                className="btn btn-outline-danger rounded-circle m-1"
                                style={{ width: '40px', height: '40px' }}
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </>
        )
    }

    function RenderLinks() {
        return (
            <>
                <h5 className="slogan_u mt-5 mb-0 pb-2">Links:</h5>

                {user.links.map((item, index) => (
                    <div key={index} className='container mt-4'>
                        <div className='d-flex justify-content-between align-items-center '>

                            <div onClick={() => window.open(item.link, "_blank")} className={`container centered-div  position-relative`}>
                                <div className="d-flex align-items-center justify-content-center position-relative w-100">
                                    <img
                                        src={`${apiEndpoint}/media/icons/link.png`}
                                        alt="Profil Fotoğrafı"
                                        className="profile-pic"
                                        style={{ width: "50px", height: "50px" }}
                                    />
                                    <div style={{ marginLeft: "-13px", marginRight: "28px" }} className="flex-grow-1 text-center">
                                        {item.title}
                                    </div>

                                </div>
                            </div>

                            <div style={{ width: "50px", paddingLeft: "10px" }}>
                                <button
                                    onClick={() => { deleteLink(item.id) }}
                                    className="btn btn-outline-danger rounded-circle m-1"
                                    style={{ width: '40px', height: '40px' }}
                                    type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                    </svg>
                                </button>
                            </div>

                        </div>
                    </div>

                ))}

            </>

        );
    }
    return (
        // <div className='full-heightuser' style={{ backgroundColor: user.background_color, position: "relative" }}>
        <div className='full-heightuser'>
            {user.is_active &&
                <button onClick={() => window.open(`${apiEndpoint}/${user.username}`, "_blank")} className="floating-button">View</button>
            }

            <div className="container d-flex flex-column justify-content-end align-items-center ">

                {/* pp */}
                <div className="mb-3 pt-3 position-relative">
                    <div>
                        <img className="profile-icon" src={user.profile_picture} alt="sa" />
                    </div>
                    {user.is_content_producer && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="#49AFFE"
                            viewBox="0 0 16 16"
                            style={{
                                position: "absolute",
                                bottom: "0px",
                                right: "0px",
                                transform: "translate(30%, 30%)", // biraz üstüne gelsin diye
                                backgroundColor: "white",

                                padding: "2px"
                            }}
                        >
                            <path d="M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                            <path d="M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM1 3a1 1 0 0 1 1-1h2v2H1zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3zm-4-2h3v2H2a1 1 0 0 1-1-1zm3-1H1V8h3zm0-3H1V5h3z" />
                        </svg>
                    )}
                </div>

                {/* edit profile button */}
                <div className="d-grid gap-2 d-sm-flex justify-content-sm-center align-items-center mb-3">
                    <h2 className='name'>{user.username} </h2>
                    <EditProfile />

                </div>

                <ChangeVisibility />

                {/* countrys and tags */}
                <div className='asd mb-3 '>
                    <p style={{ marginBottom: "0" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                            <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                        </svg> :

                        {user.profile_countrys.map((country, countryIndex) => (
                            <span className="countrys" key={countryIndex}> {country} </span>
                        ))}
                    </p>

                    <p style={{ marginBottom: "0" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                            <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                            <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                        </svg> :

                        {user.profile_tags.map((country, countryIndex) => (
                            <span className="tags" key={countryIndex}> {country} </span>
                        ))}
                    </p>
                </div>


                {/* profile text */}
                <div className={`container  bio`}>
                    <div className=" align-items-center position-relative ">

                        <div>
                            {user.profile_text}
                        </div>
                    </div>
                </div>



                <RenderSocials />

                <UpdateSocialMedia />

                <AddSocialMedia />

                <RenderManuelSocials />

                <RenderLinks />

                <AddLink />

                <div className='my-5' ></div>

            </div>
        </div>
    );
}
export default Profile;